import React, { useState, useRef, useEffect } from 'react';

export default function AudioPlayer({ src }) {
  const [playing, setPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const audioRef = useRef(null);
  const rafRef = useRef(null);

  useEffect(() => {
    return () => {
      cancelAnimationFrame(rafRef.current);
      if (audioRef.current) {
        audioRef.current.pause();
      }
    };
  }, []);

  const updateProgress = () => {
    const a = audioRef.current;
    if (a && a.duration) {
      setProgress(a.currentTime / a.duration);
    }
    if (playing) {
      rafRef.current = requestAnimationFrame(updateProgress);
    }
  };

  const toggle = () => {
    if (!audioRef.current) {
      audioRef.current = new Audio(src);
      audioRef.current.addEventListener('ended', () => {
        setPlaying(false);
        setProgress(0);
        cancelAnimationFrame(rafRef.current);
      });
    }
    if (playing) {
      audioRef.current.pause();
      setPlaying(false);
      cancelAnimationFrame(rafRef.current);
    } else {
      audioRef.current.play();
      setPlaying(true);
      rafRef.current = requestAnimationFrame(updateProgress);
    }
  };

  return (
    <button
      onClick={toggle}
      title={playing ? 'Pausa' : 'Ascolta registrazione'}
      style={{
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: 2,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 3,
        width: 70,            /* fixed width so the row never shifts */
        justifyContent: 'flex-start',
      }}
    >
      <svg width="28" height="20" viewBox="0 0 28 20">
        {/* Speaker body */}
        <rect x="1" y="6" width="5" height="8" rx="1" fill={playing ? '#1E77BD' : '#64748b'} />
        <polygon
          points="6,6 12,2 12,18 6,14"
          fill={playing ? '#1E77BD' : '#64748b'}
        />

        {/* Sound waves — only visible when playing */}
        {playing && (
          <>
            <path
              d="M14.5 7 Q17 10 14.5 13"
              fill="none"
              stroke="#1E77BD"
              strokeWidth="1.5"
              strokeLinecap="round"
              className="audio-wave audio-wave-1"
            />
            <path
              d="M17 4.5 Q21 10 17 15.5"
              fill="none"
              stroke="#1E77BD"
              strokeWidth="1.5"
              strokeLinecap="round"
              className="audio-wave audio-wave-2"
            />
            <path
              d="M19.5 2 Q25 10 19.5 18"
              fill="none"
              stroke="#1E77BD"
              strokeWidth="1.5"
              strokeLinecap="round"
              className="audio-wave audio-wave-3"
            />
          </>
        )}

        {/* When not playing, show muted lines */}
        {!playing && (
          <>
            <path
              d="M14.5 7 Q17 10 14.5 13"
              fill="none"
              stroke="#cbd5e1"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <path
              d="M17 4.5 Q21 10 17 15.5"
              fill="none"
              stroke="#cbd5e1"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </>
        )}
      </svg>

      {/* Mini progress bar — always rendered (fixed slot) so layout never shifts */}
      <div style={{
        width: 30,
        height: 3,
        background: '#e2e8f0',
        borderRadius: 2,
        overflow: 'hidden',
        opacity: playing ? 1 : 0,
        transition: 'opacity 0.2s',
      }}>
        <div style={{
          width: `${progress * 100}%`,
          height: '100%',
          background: '#1E77BD',
          borderRadius: 2,
          transition: 'width 0.1s linear',
        }} />
      </div>
    </button>
  );
}
